import { Controller } from "@hotwired/stimulus"

// A small dialog over the page - "Write to us" in the footer. The native
// <dialog> does the modal work (focus, Escape, the backdrop); this opens it
// from a link that otherwise goes to a page of its own, closes it on a tap on
// the paper around the card, and once a letter has gone, puts the form back
// for next time when the dialog is closed.
export default class extends Controller {
  static targets = ["dialog", "body"]

  connect() {
    this.blank = this.hasBodyTarget ? this.bodyTarget.innerHTML : null
  }

  open(event) {
    if (!this.hasDialogTarget || typeof this.dialogTarget.showModal !== "function") return
    event.preventDefault()
    this.restore()
    this.dialogTarget.showModal()
    // The first field a person would fill; the doorstep's unseen one is skipped.
    // Not on a phone, where focusing raises the keyboard over the sheet
    // before a person has read what it says.
    if (window.matchMedia("(pointer: fine)").matches) {
      this.dialogTarget.querySelector("input:not([type=hidden]):not([tabindex='-1']), textarea")?.focus()
    }
  }

  close() {
    if (this.hasDialogTarget && this.dialogTarget.open) this.dialogTarget.close()
  }

  // A tap on the dialog element itself is a tap on the backdrop; the card
  // fills the rest.
  away(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  closed() {
    this.restore()
  }

  // Once a letter has gone, the thanks stand until the dialog is closed; the
  // form comes back for the next.
  restore() {
    if (this.blank === null || !this.hasBodyTarget) return
    if (this.bodyTarget.querySelector(".platform-letter-sent")) this.bodyTarget.innerHTML = this.blank
  }
}
